module.exports = __webpack_public_path__ + "static/media/campanias.d49df25e.png";